var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-block"},[_c('CompanyTemplateForm',{attrs:{"templateId":_vm.templateId},on:{"done":function($event){return _vm.$router.push({name: 'settingsCompanyTemplateList'})}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }